import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { MatButtonToggle, MatButtonToggleChange, MatButtonToggleGroup } from '@angular/material/button-toggle';
import { MatIcon } from '@angular/material/icon';

export type ChartType = 'bar' | 'pie';

export const CHART_TYPE_STORAGE_KEY = 'exante-analysis-chart-type';

@Component({
  selector: 'am-chart-type-selector',
  templateUrl: './chart-type-selector.component.html',
  styleUrl: './chart-type-selector.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatButtonToggleGroup, MatButtonToggle, MatIcon],
  standalone: true,
})
export class ChartTypeSelectorComponent {
  @Input() chartType: ChartType = 'bar';
  @Output() chartTypeChanged: EventEmitter<ChartType> = new EventEmitter<ChartType>();

  updateChartType($event: MatButtonToggleChange): void {
    this.chartType = $event.value;
    this.chartTypeChanged.emit(this.chartType);
  }
}
